import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 600
    },
    center: {
      type: Boolean,
      default: true
    },
    isFooter: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    footSlot: Boolean,
    modelClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    innerVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit("update:visible");
      }
    },
    localWidth: function localWidth() {
      if (typeof this.width === 'string') return this.width;
      return "".concat(this.width, "px");
    }
  },
  methods: {
    handleConfirm: function handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel: function handleCancel() {
      this.innerVisible = false;
      this.$emit('cancel');
    }
  }
};